import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_SUBJECT, CREATING_SUBJECT, DELETE_SUBJECT, DELETING_SUBJECT, GET_SUBJECTS, GETTING_SUBJECTS, SET_SUCCESS, SUBJECTS_ERROR, UPDATE_SUBJECT, UPDATING_SUBJECT } from "../types"

export const createSubject = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_SUBJECT,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/subjects`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_SUBJECT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: "New subject created successfully!"
        })
        
    }
    catch(error){
        dispatch({
            type: SUBJECTS_ERROR,
            error
        })
    }
}

export const updateSubject = (subjectId, documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_SUBJECT,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/subjects/${subjectId}`, documentRequestPayload, { headers })
        
        dispatch({
            type: UPDATE_SUBJECT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: SUBJECTS_ERROR,
            error
        })
    }
}


export const deleteSubject = (subjectId) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_SUBJECT,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/subjects/${subjectId}`, { headers })
        
        dispatch({
            type: DELETE_SUBJECT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Subject has been deleted'
        })
        
    }
    catch(error){
        dispatch({
            type: SUBJECTS_ERROR,
            error
        })
    }
}

export const fetchSubjects = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/subjects?expand=classes.class,classes.teachers`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_SUBJECTS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_SUBJECTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: SUBJECTS_ERROR,
            error
        })
    }
}

export const clearCreatedSubject = () => async (dispatch) => {    
    dispatch({
        type: CREATE_SUBJECT,
        payload: null
    })   
}

export const clearUpdatedSubject = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_SUBJECT,
        payload: null
    })   
}

export const clearDeletedSubject = () => async (dispatch) => {    
    dispatch({
        type: DELETE_SUBJECT,
        payload: null
    })   
}